module.exports = __webpack_public_path__ + "img/member-icon-4.a3db585a.png";